import { useI18n } from "../../i18n";
import styles from "./ValueWithCurrency.module.css";

interface ValueWithCurrencyProps {
  value: number;
}

export const ValueWithCurrency = ({ value }: ValueWithCurrencyProps) => {
  const { locale, formatNumber } = useI18n();
  return (
    <span className={styles.noBreak}>
      {formatNumber(value)} {locale.currencySymbol}
    </span>
  );
};
